<template>
    <div style="height:100%;position: relative;" :gutter="20">
        <div class="refresh" @click="refreshData"><i class="el-icon-refresh"></i></div>
        <el-row style="height:100%;">
            <el-col class="grid-content" :span="6">
                <div class="bg-purple content-box">
                    <div class="property-box cape-header ">
                        <div ref="property" id="property" class="property">
                            <div class="notify-title"><img src="../../assets/u212.png" />资产统计</div>
                            <div class="property-content">
                                <div class="content-title">{{ currentNode.label }}</div>
                                <div class="b-content-box">
                                    <div class="content-item" v-if="currentNode.type == 'customer'">
                                        <div><img src="../../assets/bdz.png" /></div>
                                        <div>
                                            <p>站点</p>
                                            <p>{{ customerInfos.asset_info.site_num }}个</p>
                                        </div>
                                    </div>
                                    <div class="content-item">
                                        <div><img src="../../assets/dlsb.png" /></div>
                                        <div>
                                            <p>设备</p>
                                            <p>{{ customerInfos.asset_info.equipment_num }}个</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="b-content-box">
                                    <div class="content-item">
                                        <div><img src="../../assets/cd.png" /></div>
                                        <div>
                                            <p>测点</p>
                                            <p>{{ customerInfos.asset_info.point_num }}个</p>
                                        </div>
                                    </div>
                                    <div class="content-item">
                                        <div><img src="../../assets/cgq.png" /></div>
                                        <div>
                                            <p>传感器</p>
                                            <p>{{ customerInfos.asset_info.sensor_num }}个</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cape-footer"></div>
                    </div>
                    <div class="state-box cape-header">
                        <div class="state-header">
                            <div class="notify-title">
                                <img src="../../assets/u231.png" alt="">
                                设备状态统计
                            </div>
                            <div class="chart-legend">
                                <div class="legend-item">
                                    <span class="legend-color" style="background: #55a6f7ff;"></span>
                                    <span class="legend-text">设备总数</span>
                                </div>
                                <div class="legend-item">
                                    <span class="legend-color" style="background: #58e981;"></span>
                                    <span class="legend-text">正常</span>
                                </div>
                                <div class="legend-item">
                                    <span class="legend-color" style="background: #ffc107;"></span>
                                    <span class="legend-text">预警</span>
                                </div>
                                <div class="legend-item">
                                    <span class="legend-color" style="background: #ff4b4b;"></span>
                                    <span class="legend-text">报警</span>
                                </div>
                            </div>
                        </div>
                        <div class="scroll-box-x">
                            <div ref="state" id="state" class="state"
                                :style="{ minWidth: getStateChartMinWidth() }"></div>
                        </div>
                        <div class="cape-footer"></div>
                    </div>
                    <div class="unusual-box cape-header ">
                        <div ref="unusual" id="unusual" class="unusual"></div>
                        <div class="cape-footer"></div>
                    </div>
                </div>
            </el-col>
            <el-col class="grid-content content-box" :span="12">
                <div class="content-box middle-content-box">
                    <div class="map-box">
                        <div v-if="isMapNavigation">
                            <div class="map-tree">
                                <div class="map-tree-title">
                                    <span>地图导航</span>
                                    <el-button type="text" size="mini" @click="toggleNavigation" style="margin-left:10px; color:#fff;">{{ isMapNavigation ? '查看线路导航' : '查看地图导航' }}</el-button>
                                    <i class="el-icon-search" @click="showSearch" style="padding-left:2px;" v-if="!isFold"></i>
                                    <span style="display:inline-block;" @click="toggleFold">
                                        <i :class="[isFoldClass]"></i>
                                    </span>
                                </div>
                                <el-input v-if="showSearchBox" clearable
                                        placeholder="输入关键字进行过滤"
                                        v-model="filterText">></el-input>
                                <tree :type="'site'" :data="treeData"
                                    :currentKey="currentKey"
                                    :expandOnClickCustomerNodeFlag="false"
                                    :isDefaultExpandFirst = "isDefaultExpandFirst"
                                    @clickNode="clickNode"
                                    @doubleClick="doubleClick"
                                    ref="trees" v-if="treeData.length"></tree>
                            </div>
                            <amap class="map" :mapData="mapData"></amap>
                        </div>
                        <div v-else class="line-navigation" :class="{ 'fullscreen': isLineFullscreen }">
                            <div class="map-tree" style="width: 100%; height: 100%; position: relative;">
                                <div class="map-tree-title">
                                    <span>线路导航</span>
                                    <el-button type="text" size="mini" @click="toggleNavigation" style="margin-left:10px; color:#fff;">{{ isMapNavigation ? '查看线路导航' : '查看地图导航' }}</el-button>
                                    <el-button type="text" size="mini" @click="toggleLineFullscreen" style="margin-left:10px; color:#fff;">
                                        <i :class="isLineFullscreen ? 'el-icon-full-screen' : 'el-icon-full-screen'"></i> {{ isLineFullscreen ? '退出全屏' : '全屏' }}
                                    </el-button>
                                </div>
                                <div class="line-content" style="height: calc(100% - 38px);">
                                    <div class="company-container">
                                        <div v-for="company in treeData" :key="company.id" class="company-section">
                                            <div class="company-header">
                                                <div class="company-title">{{ company.label }}</div>
                                                <div class="company-stats">
                                                    <span class="stat-item">站点数: {{ company.children.length }}</span>
                                                </div>
                                            </div>
                                            <div class="site-grid">
                                                <div v-for="site in company.children" :key="site.id" class="site-card" :class="{ 
                                                    'has-alarm': (site.unprocessed_alarm_num > 0 || (site.unprocessed_warning_num > 0 && site.unprocessed_alarm_num > 0)), 
                                                    'has-warning': (site.unprocessed_warning_num > 0 && site.unprocessed_alarm_num == 0)
                                                }">
                                                    <div class="site-header">
                                                        <div class="site-name">{{ site.label }}</div>
                                                        <div class="site-status" :class="{ 
                                                            'status-alarm': (site.unprocessed_alarm_num > 0 || (site.unprocessed_warning_num > 0 && site.unprocessed_alarm_num > 0)), 
                                                            'status-warning': (site.unprocessed_warning_num > 0 && site.unprocessed_alarm_num == 0),
                                                            'status-normal': (site.unprocessed_warning_num == 0 && site.unprocessed_alarm_num == 0)
                                                        }">
                                                            {{ (site.unprocessed_alarm_num > 0 || (site.unprocessed_warning_num > 0 && site.unprocessed_alarm_num > 0)) ? '告警' : (site.unprocessed_warning_num > 0 && site.unprocessed_alarm_num == 0) ? '预警' : '正常' }}
                                                        </div>
                                                    </div>
                                                    <div class="site-actions">
                                                        <button class="action-btn detail-btn" @click="gotoSiteDetail(site)">
                                                            <i class="el-icon-view"></i> 详情
                                                        </button>
                                                        <button class="action-btn alarm-btn" @click="gotoAlarmPage(site)">
                                                            <i class="el-icon-warning"></i> 告警
                                                            <span class="alarm-badge" v-if="site.unprocessed_num > 0">{{ site.unprocessed_num }}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div  ref="map" class="map"></div> -->
                    <div class="notify cape-header">
                        <div class="notify-title"><img src="../../assets/u233.png" />最新异常通知</div>
                        <div class="notify-table">
                            <el-table :data="tableData" height="100%" style="width: 100%">
                                <el-table-column prop="create_date" label="报警时间" width="135"></el-table-column>
                                <!--<el-table-column prop="equipment_name" show-overflow-tooltip
                                    label="设备名称"></el-table-column> -->
                                <el-table-column prop="point_name" show-overflow-tooltip label="测点名称"></el-table-column>
                                <el-table-column prop="site_name" show-overflow-tooltip label="站点名称"></el-table-column>
                                <!--<el-table-column prop="pointName" label="测点名称"></el-table-column>-->
                                <el-table-column prop="sensor_type" width="90" label="传感器类型"></el-table-column>
                                <el-table-column align="center" label="报警状态" width="100">
                                    <template slot-scope="props">
                                        <p>{{ alarmLevel[props.row.alarm_level] }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="mini" @click="handle(scope.row)">确认</el-button>
                                        <el-button type="text" size="mini" @click="showChart(scope.row)">查看</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="cape-footer"></div>
                    </div>
                </div>
            </el-col>
            <el-col class="grid-content content-box" :span="6">
                <div class="content-box right-chart-column">
                    <div class="point-box cape-header">
                        <div class="scroll-box-y">
                            <div class="chart-title">
                                <img src="../../assets/u234.png" alt="">
                                监测测点类型状态分布
                            </div>
                            <div ref="point"
                              class="point"
                              :style="{ minHeight: getPointChartMinHeight(), marginTop: '20px' }"></div>
                        </div>
                        <div class="cape-footer point-cape-footer"></div>
                    </div>
                    <div class="online-box cape-header ">
                        <div class="scroll-box-y">
                            <div ref="online" class="online"></div>
                        </div>
                        <div class="cape-footer"></div>
                    </div>
                    <div class="fault-box cape-header ">
                        <div class="scroll-box-y">
                            <div ref="fault" class="fault"></div>
                        </div>
                        <div class="cape-footer"></div>
                    </div>
                    <div ref="unusual-deal" class="unusual-deal  cape-header">
                        <div class="notify-title"><img src="../../assets/u236.png" />异常情况处理统计</div>
                        <div class="deal-box">
                            <div class="deal-describ">
                                <span><i class="el-icon-message-solid"></i></span>
                                <p>处理数/异常数</p>
                                <p>累计总数</p>
                            </div>
                            <div class="deal-num">
                                <table style="width:80%;margin-top:2px;">
                                    <tr>
                                        <td>本日</td>
                                        <td>本周</td>
                                        <td>本月</td>
                                    </tr>
                                    <tr>
                                        <!-- <td>{{ countAbnormal.dayProcessedNum + ' / ' + countAbnormal.dayAlarmNum }}</td>
                                        // <td>{{ countAbnormal.weekProcessedNum + ' / ' + countAbnormal.weekAlarmNum }}
                                        // </td>
                                        // <td>{{ countAbnormal.monthProcessedNum + ' / ' + countAbnormal.monthAlarmNum }}
                                        // </td>-->
                                        <td class="link" @click="toWarning(1)">{{ countAbnormal.dayProcessedNum + ' / ' + countAbnormal.dayAlarmNum }}</td>
                                        <td class="link" @click="toWarning(7)">{{ countAbnormal.weekProcessedNum + ' / ' + countAbnormal.weekAlarmNum }}
                                        </td>
                                        <td  class="link" @click="toWarning(30)">{{ countAbnormal.monthProcessedNum + ' / ' + countAbnormal.monthAlarmNum }}
                                        </td>
                                    </tr>
                                    <tr style="text-align:center;">
                                        <td colspan="3" class="link" @click="toWarning(0)">{{ countAbnormal.sumProcessedNum + ' / '+countAbnormal.sumAlarmNum}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="cape-footer"></div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div v-if="showDetails">
            <Details v-if="showDetails" :visible.sync="showDetails" :detailsInfo="detailsInfo" @clickNode="clickNode">
            </Details>
        </div>
        <div v-if="showChartDetails">
            <chartDetails :visible.sync="showChartDetails" :dataDetails="dataDetails"></chartDetails>
        </div>
        <div  v-if="showTrendDetails">
             <chart :visible.sync="showTrendDetails" :trendCharData="trend_char_data" :selectData="trendSelectData" :currentNode="currentNode" :total="siteTotal"></chart>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
// import 'echarts/extension/bmap/bmap'
import amap from './map.vue';
import tree from '@/components/tree.vue'
import * as device from '@/data/device.js'
import * as warning from '@/data/warning.js'
import * as map from '@/data/map.js'
// import  Details  from '../warning/details.vue';
import Bus from "@/util/Bus.js";
import { sensorTypeOptions, alarmLevel, sensorTypeDic } from "@/util/sensorType.js"
export default {
    name: 'Sum',
    components: {
        amap, tree,
        Details: resolve => { require(['../warning/details.vue'], resolve) },
        chartDetails: resolve => { require(['../site/chartDetails.vue'], resolve) },
        chart: resolve => { require(['../site/chart.vue'], resolve) },
    },
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            alarmLevel,
            sensorTypeDic,
            myChart: null,
            myChart1: null,
            myChart2: null,
            myChart3: null,
            myChart4: null,

            tableData: [],
            isDefaultExpandFirst: true,
            treeData: [],
            customerInfos: {
                asset_info: {},
                point_distribution_info: []
            },
            abnormalInfos: {},
            countAbnormal: {},
            mapData: [],
            currentNode: {},
            showDetails: false,
            isFoldClass: 'el-icon-s-fold',
            isFold: false,
            showChartDetails: false,
            currentKey: '',
            charts2Len: 1,
            charts4Len: 1,
            intervalId: null,
            showSearchBox: false,
            filterText: '',
            showTrendDetails: false,
            trend_char_data:{},
            trendSelectData: [],
            siteTotal: 1000,
            loading: null,
            isMapNavigation: JSON.parse(sessionStorage.getItem('isMapNavigation') || 'true'),
            isLineFullscreen: false,
            resizeTimer: null,
            statusRequestSeq: 0
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getTreeData();
        })
        Bus.$on('wsData', this.wsDataBySum)
        window.addEventListener('resize', this.handleWindowResize)
        this.intervalId = setInterval(this.clickNode, 3600000, null, true)
    },
    beforeDestroy() {
        // 注销事件监听器
        Bus.$off('wsData', this.wsDataBySum);
        window.removeEventListener('resize', this.handleWindowResize)
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        if (this.resizeTimer) {
            clearTimeout(this.resizeTimer);
        }
        this.disposeCharts();
    },
    watch: {
      filterText(val) {
        this.$refs.trees.filterData(val);
      },
    },
    methods: {
        toWarning(day) {
            let searchForm = {
                point_name: '',
                is_online: '',
                is_processed: 'false',
                alarm_type: 2,
                alarm_level: '',
                sensor_type: '',
                start_date: day > 0 ? this.formatDate(new Date(new Date().getTime() - day * 24 * 60 * 60 * 1000)) : '',
                end_date: day > 0 ? this.formatDate(new Date(new Date().getTime())) : ''
            }
            this.$router.push({name: 'warning', params: {searchForm: searchForm}})
        },
        formatDate(date) {
            return date.getFullYear() + '-' + this.timeFormat(date.getMonth() + 1) + '-' + this.timeFormat(date.getDate()) + ' ' + this.timeFormat(date.getHours()) + ':' + this.timeFormat(date.getMinutes()) + ':' + this.timeFormat(date.getSeconds());
        },
        timeFormat(v) {
            return v < 10 ? '0' + v : v
        },
        showSearch(){
            this.showSearchBox = !this.showSearchBox ;
        },
        wsDataBySum(target) {
            target = JSON.parse(target);
            let data = target.message.data
            let type = this.currentNode.type;
            if (data.abnormal_count_info) {
                //异常情况处理统计
                this.setCountAbnormal(data.abnormal_count_info[type + '_abnormal_info'], type);
            }
            //最新三条报警
            if (data.latest3_alarm) {
                //还需要判断下报警的这条是否在当前公司或站点下
                this.tableData.pop();
                this.tableData.unshift(data.alarm_data);
            }
        },
        toggleFold() {
            this.isFold = !this.isFold;
            let style = this.isFold ? { width: '35px' } : { width: '200px' }
            let heightStyle = this.isFold ? { height: '110px' } : { height: '300px', 'max-height': 'calc(100% - 100px)' }
        },
        toggleLineFullscreen() {
            this.isLineFullscreen = !this.isLineFullscreen;
            this.resizeCharts();
        },
        toggleNavigation() {
            this.isMapNavigation = !this.isMapNavigation;
            // 保存导航状态到缓存
            sessionStorage.setItem('isMapNavigation', JSON.stringify(this.isMapNavigation));
            this.resizeCharts();
        },
        gotoSiteDetail(site) {
            // 更新缓存中的当前节点信息
            sessionStorage.setItem('currentNode', JSON.stringify(site));
            this.$router.replace({ name: 'site', params: { obj: site } });
        },
        gotoAlarmPage(site) {
            // 更新缓存中的当前节点信息
            sessionStorage.setItem('currentNode', JSON.stringify(site));
            // 跳转到报警管理页面
            this.$router.replace({ name: 'warning', params: { site_id: site.id, site_name: site.label } });
        },
        doubleClick(obj) {
            // 更新缓存中的当前节点信息
            sessionStorage.setItem('currentNode', JSON.stringify(obj));
            this.$router.replace({ name: 'site', params: { obj: obj } });
        },
        // 刷新数据
        refreshData() {
            this.getTreeData(true)
        },
        getTreeData(bool = false) {
            let This = this;
            device.queryTrees().then(res => {
                if (!res) return;
                This.treeData = res.data;
                
                // 为每个站点添加has_alarm字段
                This.treeData.forEach(company => {
                    if (company.children && company.children.length > 0) {
                        company.children.forEach(site => {
                            site.has_alarm = false; // 默认没有报警
                        });
                    }
                });
                
                // 获取公司的报警信息，更新站点的has_alarm字段
                This.treeData.forEach(company => {
                    map.customerAbnormal({ customer_id: company.id }).then(res => {
                        if (res && res.data) {
                            // 检查是否有报警
                            let hasAlarm = false;
                            for (let key in res.data) {
                                if (res.data[key] > 0) {
                                    hasAlarm = true;
                                    break;
                                }
                            }
                            
                            // 更新该公司下所有站点的has_alarm字段
                            if (company.children && company.children.length > 0) {
                                company.children.forEach(site => {
                                    site.has_alarm = hasAlarm;
                                });
                            }
                        }
                    });
                });
                
                const str = sessionStorage.getItem('currentNode');
                let node;
                if(str){
                    node = JSON.parse(str)
                    this.isDefaultExpandFirst = false;
                }else {
                    node = res.data[0].children[0];
                }
                this.currentKey = node.id
                This.clickNode(node, bool);
                this.$nextTick(() => {
                    this.$refs.trees.$refs.tree.setCurrentKey(this.currentKey);
                });
            })
        },
        clickNode(v, is_refresh) {
            if (!v || !v.type) {
                v = this.currentNode
            }
            let This = this;
            const statusRequestSeq = ++this.statusRequestSeq;
            this.currentKey = v.id
            this.currentNode = v;
            if (v.type == "customer") {
                this.mapData = v.children;
                this.customerStatus(v.id, v.type, is_refresh, statusRequestSeq)
                map.abnormalRatio({ customer_id: v.id }).then(res => {
                    this.abnormalInfos = res.data;
                    this.initCharts3();
                })
                map.customerLatestAlarms({ customer_id: v.id }).then(res => {
                    this.tableData = res.data;
                })
                map.customerAbnormal({ customer_id: v.id }).then(res => {
                    let tmp = res.data
                    this.setCountAbnormal(tmp, 'customer')
                })
            } else if (v.type == "site") {
                if(this.mapData.length == 0){
                  //查找站点公司
                  let customerNode = this.getNode(This.treeData, (item)=>{
                      return v.parent_id == item.id
                  })
                  if(customerNode){
                    this.mapData = customerNode.children;
                  }
                }
                this.siteStatus(v.id, v.type, is_refresh, statusRequestSeq)
                map.siteLatestAlarms({ site_id: v.id }).then(res => {
                    this.tableData = res.data;
                })
                map.siteAbnormalRatio({ site_id: v.id }).then(res => {
                    this.abnormalInfos = res.data;
                    this.initCharts3();
                })
                map.siteAbnormal({ site_id: v.id }).then(res => {
                    let tmp = res.data;
                    this.setCountAbnormal(tmp, 'site')
                })
            }
        },
        getNode(nodes,func){
          for (const item of nodes) {
              if (func(item)) return item
          }
          return null
        },
        // 异常情况处理统计
        setCountAbnormal(obj, type) {
            this.countAbnormal = {
                dayProcessedNum: obj[type + '_day_abnormal_info'].processed_num,
                dayAlarmNum: obj[type + '_day_abnormal_info'].alarm_num,
                weekProcessedNum: obj[type + '_week_abnormal_info'].processed_num,
                weekAlarmNum: obj[type + '_week_abnormal_info'].alarm_num,
                monthProcessedNum: obj[type + '_month_abnormal_info'].processed_num,
                monthAlarmNum: obj[type + '_month_abnormal_info'].alarm_num,
                sumProcessedNum: obj[type + '_total_abnormal_info'].processed_num,
                sumAlarmNum: obj[type + '_total_abnormal_info'].alarm_num
            };
        },
        customerStatus(id, type, is_refresh = false, statusRequestSeq = this.statusRequestSeq) {
            map.companyStatus({ customer_id: id, data: { is_refresh: is_refresh } }).then(res => {
                if (statusRequestSeq !== this.statusRequestSeq) return;
                this.customerInfos = res.data;
                this.initCharts2();
                this.initCharts4();
                this.initCharts5();
                this.initCharts6();
            })
        },
        siteStatus(id, type, is_refresh = false, statusRequestSeq = this.statusRequestSeq) {
            map.siteStatus({ site_id: id, data: { is_refresh: is_refresh } }).then(res => {
                if (statusRequestSeq !== this.statusRequestSeq) return;
                this.customerInfos = res.data;
                this.initCharts2();
                this.initCharts4();
                this.initCharts5();
                this.initCharts6();
            })
        },
        initCharts() {
            //设备状态统计
            this.initCharts2();
            //电力设备异常率趋势
            this.initCharts3();
            //监测测点类型状态分布
            this.initCharts4();
            //传感器在线率
            this.initCharts5();
            //传感器故障率
            this.initCharts6();

        },
        getChartTooltipOption(option = {}) {
            return Object.assign({
                confine: true,
                appendToBody: true,
                extraCssText: 'z-index: 999999; max-width: 360px; white-space: normal;'
            }, option)
        },
        getChartInstances() {
            return [this.myChart, this.myChart1, this.myChart2, this.myChart3, this.myChart4].filter(Boolean)
        },
        handleWindowResize() {
            if (this.resizeTimer) {
                clearTimeout(this.resizeTimer);
            }
            this.resizeTimer = setTimeout(() => {
                this.resizeCharts();
            }, 100);
        },
        resizeCharts() {
            this.$nextTick(() => {
                this.getChartInstances().forEach(chart => {
                    chart.resize();
                })
            })
        },
        disposeCharts() {
            this.getChartInstances().forEach(chart => {
                chart.dispose();
            })
        },
        getStateChartMinWidth() {
            return Math.max(360, this.charts2Len * 72) + 'px';
        },
        getPointChartMinHeight() {
            return Math.max(220, 80 + this.charts4Len * 200) + 'px';
        },
        // 设备状态统计
        initCharts2() {
            let statusList = this.customerInfos.equipment_status_info;
            let alarmList = [], normalList = [], warningList = [], sumList = [], siteNameList = [];
            statusList.forEach(item => {
                let alarm_num = item.alarm_num + item.long_trend_alarm_num + item.short_trend_alarm_num
                let warning_num = item.warning_num + item.long_trend_warning_num + item.short_trend_warning_num
                let normal_num = item.normal_num
                let total = item.total
                alarmList.push(alarm_num)
                normalList.push(normal_num)
                warningList.push(warning_num)
                sumList.push(total)
                siteNameList.push(item.site_name ? item.site_name : item.device_type)
            })
            if (this.myChart) this.myChart.dispose()
            this.myChart = echarts.init(this.$refs.state);
            // 计算图的个数
            this.charts2Len = statusList.length;
            var option = {
                grid: {
                    left: 45,
                    right: 16,
                    bottom: '15%',
                    top: '10%'
                },
                tooltip: this.getChartTooltipOption({
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                }),
                legend: {
                    show: false
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: { show: false },
                        data: siteNameList,
                        showMinLabel: 0,
                        axisLabel: {
                            color: '#fff',
                            interval: 0,
                            width: 64,
                            overflow: 'truncate'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                    }
                ],
                series: [
                    {
                        name: '设备总数',
                        type: 'bar',
                        barGap: 0,
                        data: sumList,
                        barMinHeight: 3,
                        barWidth: 18,
                        label: {
                            show: true,
                            color: '#ffffff',
                            position: 'inside'
                        },
                        itemStyle: {
                            color: '#55a6f7ff', // 设备总数：蓝色
                        }
                    },
                    {
                        name: '正常',
                        type: 'bar',
                        data: normalList,
                        barMinHeight: 3,
                        barWidth: 18,
                        label: {
                            show: true,
                            color: '#ffffff',
                            position: 'inside'
                        },
                        itemStyle: {
                            color: '#58e981ff', 
                        }
                    },
                    {
                        name: '预警',
                        type: 'bar',
                        data: warningList,
                        barMinHeight: 3,
                        barWidth: 18,
                        label: {
                            show: true,
                            color: '#ffffff',
                            position: 'inside'
                        },
                        itemStyle: {
                            color: '#f7d755ff', 
                        }
                    },
                    {
                        name: '报警',
                        type: 'bar',
                        data: alarmList,
                        barMinHeight: 3,
                        barWidth: 18,
                        label: {
                            show: true,
                            color: '#ffffff',
                            position: 'inside'
                        },
                        itemStyle: {
                            color: '#ff4c4cff', 
                        }
                    }
                ]
            };
            this.myChart.setOption(option, true);
            this.resizeCharts();
        },
        // 电力设备异常率趋势
        initCharts3() {
            var data = this.abnormalInfos;
            if (this.myChart1) this.myChart1.dispose()
            this.myChart1 = echarts.init(this.$refs.unusual);
            var option = {
                title: {
                    text: "{A|     电力设备异常率趋势}",
                    top: 4,
                    textStyle: {
                        color: '#fff',
                        rich: {
                            A: {
                                width: 20,
                                height: 20,
                                fontSize: 16,
                                backgroundColor: {
                                    image: require("../../assets/u232.png")
                                }
                            }
                        }
                    }
                },
                tooltip: this.getChartTooltipOption({
                    trigger: 'axis',
                    formatter: function (params) {
                        return params[0].name.split('T')[0] + '<br/>' + (params[0].value) + '%'
                    }
                }),
                grid: {
                    left: '16%',
                    right: '10%',
                    bottom: '10%'
                },
                xAxis: {
                    type: 'category',
                    data: data.map(function (item) {
                        return item[0];
                    }),
                    axisLabel: {
                        color: '#fff',
                        showMinLabel: 0,
                        // 时间
                        formatter: function (value) {
                            let arr = value.split('T')
                            return arr[0]
                        }
                    }

                },
                yAxis: {
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#fff',
                        formatter: function (value) {
                            return value + '%'
                        }
                    },
                    min: 0, // 设置最小刻度值
                    max: 100, // 设置最大刻度值
                    axisTick: {
                        alignWithLabel: true
                    }
                },
                visualMap: {
                    type: "piecewise",
                    top: 10,
                    right: 10,
                    textStyle: {
                        color: '#fff'
                    },
                    /* pieces : [
                        { min : 150 , color : 'brown' },
                        { min : 120 , max : 150 , color : 'purple' },
                        { min : 90 , max : 120 , color : 'red' },
                        { min : 60 , max : 90 , color : 'orange' },
                        { min : 25 , max : 60 , color : 'yellow' },
                        { max : 0.5 , color : 'green' }
                    ] */
                    pieces: [
                        {
                            gt: 51,
                            lte: 100,
                            color: '#ff4b4bff',
                            label: '>50%'
                        },
                        {
                            gte: 0,
                            lte: 51,
                            color: '#8ae86aff',
                            label: '<=50%'
                        }
                    ]
                },
                series: [
                    {
                        data: data.map(function (item) {
                            return item[1]*100;
                        }),
                        type: 'line',
                        symbolSize: 4,
                        lineStyle: {
                            width: 1.3 // 设置线条粗细为3
                        },
                        markLine: {
                            symbol: 'none',
                            label: {
                                show: false,
                            },
                            data: [{
                                yAxis: 20
                            }, {
                                yAxis: 40
                            }, {
                                yAxis: 60
                            }, {
                                yAxis: 80
                            }, {
                                yAxis: 100
                            }]
                        }

                    }
                ]
            };
            this.myChart1.setOption(option);
            this.resizeCharts();
        },
        // 监测测点类型状态分布
        initCharts4() {
            const tmp = this.customerInfos.point_distribution_info || [];
            let obj = {};
            tmp.forEach(item => {
                const sensorTypeItem = sensorTypeOptions.find(i => i.type === item.sensor_type)
                if (!sensorTypeItem) return
                let warning_num = item.warning_num + item.long_trend_warning_num + item.short_trend_warning_num
                let alarm_num = item.alarm_num + item.long_trend_alarm_num + item.short_trend_alarm_num
                let normal_num = item.normal_num
                obj[item.sensor_type] = [
                    { value: alarm_num + normal_num + warning_num, name: '总数：' + (alarm_num + normal_num + warning_num), itemStyle: {color:'#55a6f7ff'} },
                    { value: normal_num, name: '正常：' + normal_num , itemStyle: {color:'#8ae86aff'}},
                    { value: warning_num, name: '预警：' + warning_num, itemStyle: {color:'#fefe56ff'}},
                    { value: alarm_num, name: '报警：' + alarm_num , itemStyle: {color:'#ff4b4bff'}},
                ]
            })
            const chartTypes = Object.keys(obj)
            this.charts4Len = chartTypes.length || 1;
            var option = {
                title: [],
                tooltip: this.getChartTooltipOption({
                    trigger: 'item',
                    formatter: '{a} <br/>{b}'
                }),
                stillShowZeroSum: true,
                legend: {
                    textStyle: {
                        color: '#fff',
                    },
                    left: 'center',
                    top: "32px",
                    data: ['总数', '正常', '预警', '报警']
                },
                series: []
            };
            chartTypes.forEach((item, index) => {
                const sensorTypeItem = sensorTypeOptions.find(i => i.type === item)
                const titleObj = {
                    text: sensorTypeItem.label,
                    left: '38%',//居中显示
                    top: 80 + 100 + index * 200 + 'px',//底部显示
                    textStyle: {
                        color: '#fff',
                        fontSize: 12
                    }
                };
                const seriesObj = {
                    name: sensorTypeItem.label,
                    type: 'pie',
                    radius: [10, 60],
                    center: ['45%', 100 + index * 200 + 'px'],
                    roseType: 'area',
                    label: {
                        show: true,
                        color: '#ffffff',
                        fontStyle: 'normal',
                        shadowColor: 'transparent'
                    },
                    data: obj[item]
                }
                option.title.push(titleObj);
                option.series.push(seriesObj);
            })
            this.$nextTick(() => {
                if (this.myChart2) this.myChart2.dispose()
                this.myChart2 = echarts.init(this.$refs.point);
                const that = this
                this.myChart2.on('click', function (param) {
                    const sensorTypeItem = sensorTypeOptions.find(i => i.label === param.seriesName)
                    if (!sensorTypeItem) return
                    if([2,3].includes(param.dataIndex)){
                        let searchForm = {
                            point_name: '',
                            is_online: '',
                            is_processed: 'false',
                            alarm_type: 2,
                            alarm_level: '',
                            sensor_type: sensorTypeItem.type,
                        }
                        that.$router.push({name: 'warning', params: {searchForm: searchForm}})
                    }
                });
                this.myChart2.setOption(option, true);
                this.resizeCharts();
            })
        },
        // 传感器在线率
        initCharts5() {
            if (this.myChart3) this.myChart3.dispose()
            this.myChart3 = echarts.init(this.$refs.online);
            let yArr = [];
            let y = [];
            let sensorArr = [];
            for (let i = 0; i < this.customerInfos.sensor_online_ratio.length; i++) {
                yArr.push(Object.keys(this.customerInfos.sensor_online_ratio[i]))
            }
            for (let i = 0; i < yArr.length; i++) {
                y.push(yArr[i][0])
            }
            for (let i = 0; i < this.customerInfos.sensor_online_ratio.length; i++) {
                sensorArr.push(this.getProperty(this.customerInfos.sensor_online_ratio[i], y[i]))
            }
            let yAxisData = []
            let seriesData1 = []
            let seriesData2 = []
            for (let i = 0; i < sensorArr.length; i++) {
                if (sensorArr[i].total > 0) {
                    //传感器名称
                    sensorArr[i].name = sensorTypeDic[y[i]]
                    yAxisData.push(sensorArr[i].name)
                    seriesData1.push((sensorArr[i].online_count / sensorArr[i].total) * 100 || 0);
                    seriesData2.push((sensorArr[i].offline_count / sensorArr[i].total) * 100 || 0);
                }
            }
            let option = {
                color: ['#61DDAA', 'red'],
                title: {
                    text: "{A|     传感器在线率}",
                    top: 4,
                    textStyle: {
                        color: '#fff',
                        rich: {
                            A: {
                                width: 20,
                                height: 20,
                                fontSize: 16,
                                backgroundColor: {
                                    image: require("../../assets/u235.png")
                                }
                            }
                        }
                    }
                },
                tooltip: this.getChartTooltipOption({
                    trigger: 'axis',
                    axisPointer: {
                        // Use axis to trigger tooltip
                        type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                    },
                    formatter: function (data) {
                        var text = data[0].name + '\n', val;
                        for (var i = 0; i < data.length; i++) {
                            text += data[i].marker + data[i].seriesName + ': ' + Math.round(data[i].value) + '%' + '\n';
                        }
                        return text;
                    }
                }),
                legend: {
                    textStyle: {//图例文字的样式
                        color: '#fff',
                        fontSize: 10
                    },
                    top: "32px"
                },
                grid: {
                    left: '3%',
                    right: '8%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    max: 100,
                    axisLabel: {
                        show: true,
                        interval: 'auto',
                        color: '#fff',
                        formatter: '{value}%'
                    }
                },
                yAxis: {
                    type: 'category',
                    data: yAxisData,
                    axisLabel: {
                        color: '#fff',
                        interval: 0 // 设置y轴所有标签都显示
                    }
                },
                series: [
                    {
                        name: '在线',
                        type: 'bar',
                        stack: 'total',
                        barWidth: '4',
                        data: seriesData1,
                        label: {
                            show: false,
                            color: '#fff',
                            position: 'insideRight',
                            fontSize: '12',
                            formatter: function (params) {
                                if (params.value == 0) {  //为0时不显示
                                    return ''
                                } else {
                                    return params.value.toFixed(2) / 100 + '%'
                                }
                            }
                        }
                    },
                    {
                        name: '离线',
                        type: 'bar',
                        stack: 'total',
                        barWidth: '4',
                        data: seriesData2,
                        barIds: seriesData2,
                        label: {
                            show: false,
                            color: '#fff',
                            position: 'insideRight',
                            fontSize: '12',
                            formatter: function (params) {
                                if (params.value == 0) {  //为0时不显示
                                    return ''
                                } else {
                                    return params.value.toFixed(2) / 100 + '%'
                                }
                            }
                        }
                    }
                ]
            };
            const that = this
            this.myChart3.on('click', function (param) { 
                let searchForm = {
                    point_name: '',
                    is_online: 'false',
                    is_processed: 'false',
                    alarm_type: 1,
                    alarm_level: '',
                    sensor_type:  sensorTypeOptions.find(i => i.label === param.name).type,
                    start_date: '',
                    end_date: ''
                }
                that.$router.push({name: 'warning', params: {searchForm: searchForm}})

            });
            this.myChart3.setOption(option);
            this.resizeCharts();
        },
        // 传感器故障率
        initCharts6() {
            if (this.myChart4) this.myChart4.dispose()
            this.myChart4 = echarts.init(this.$refs.fault);
            const faultRatio = this.customerInfos.sensor_fault_ratio || [];
            let yArr = [];
            let y = [];
            let sensorArr = [];
            for (let i = 0; i < faultRatio.length; i++) {
                yArr.push(Object.keys(faultRatio[i]))
            }
            for (let i = 0; i < yArr.length; i++) {
                y.push(yArr[i][0])
            }
            for (let i = 0; i < faultRatio.length; i++) {
                sensorArr.push(this.getProperty(faultRatio[i], y[i]))
            }
            let yAxisData = []
            let seriesData1 = []
            let seriesData2 = []
            let seriesData3 = []
            for (let i = 0; i < sensorArr.length; i++) {
                if (sensorArr[i].total > 0) {
                    sensorArr[i].name = sensorTypeDic[y[i]]
                    yAxisData.push(sensorArr[i].name)
                    const total = sensorArr[i].total
                    const faultCount = sensorArr[i].fault_count || 0
                    const normalCount = sensorArr[i].normal_count || 0
                    const unreportedCount = Math.max(0, total - faultCount - normalCount)
                    seriesData1.push((faultCount / total) * 100 || 0);
                    seriesData2.push((normalCount / total) * 100 || 0);
                    seriesData3.push((unreportedCount / total) * 100 || 0);
                }
            }
            let option = {
                color: ['red', '#61DDAA', '#9ca3af'],
                title: {
                    text: "{A|     传感器故障率}",
                    top: 4,
                    textStyle: {
                        color: '#fff',
                        rich: {
                            A: {
                                width: 20,
                                height: 20,
                                fontSize: 16,
                                backgroundColor: {
                                    image: require("../../assets/u235.png")
                                }
                            }
                        }
                    }
                },
                tooltip: this.getChartTooltipOption({
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (data) {
                        var text = data[0].name + '\n', val;
                        for (var i = 0; i < data.length; i++) {
                            text += data[i].marker + data[i].seriesName + ': ' + Math.round(data[i].value) + '%' + '\n';
                        }
                        return text;
                    }
                }),
                legend: {
                    textStyle: {
                        color: '#fff',
                        fontSize: 10
                    },
                    top: "32px"
                },
                grid: {
                    left: '3%',
                    right: '8%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    max: 100,
                    axisLabel: {
                        show: true,
                        interval: 'auto',
                        color: '#fff',
                        formatter: '{value}%'
                    }
                },
                yAxis: {
                    type: 'category',
                    data: yAxisData,
                    axisLabel: {
                        color: '#fff',
                        interval: 0
                    }
                },
                series: [
                    {
                        name: '故障',
                        type: 'bar',
                        stack: 'total',
                        barWidth: '4',
                        data: seriesData1,
                        label: {
                            show: false,
                            color: '#fff',
                            position: 'insideRight',
                            fontSize: '12',
                            formatter: function (params) {
                                if (params.value == 0) {
                                    return ''
                                } else {
                                    return params.value.toFixed(2) / 100 + '%'
                                }
                            }
                        }
                    },
                    {
                        name: '正常',
                        type: 'bar',
                        stack: 'total',
                        barWidth: '4',
                        data: seriesData2,
                        label: {
                            show: false,
                            color: '#fff',
                            position: 'insideRight',
                            fontSize: '12',
                            formatter: function (params) {
                                if (params.value == 0) {
                                    return ''
                                } else {
                                    return params.value.toFixed(2) / 100 + '%'
                                }
                            }
                        }
                    },
                    {
                        name: '未上报',
                        type: 'bar',
                        stack: 'total',
                        barWidth: '4',
                        data: seriesData3,
                        label: {
                            show: false,
                            color: '#fff',
                            position: 'insideRight',
                            fontSize: '12',
                            formatter: function (params) {
                                if (params.value == 0) {
                                    return ''
                                } else {
                                    return params.value.toFixed(2) / 100 + '%'
                                }
                            }
                        }
                    }
                ]
            };
            const that = this
            this.myChart4.on('click', function (param) {
                if (param.seriesName === '未上报') return
                const sensorTypeItem = sensorTypeOptions.find(i => i.label === param.name)
                if (!sensorTypeItem) return
                that.$router.push({
                    name: 'warning',
                    params: {
                        activeTab: 'selfcheck',
                        selfCheckSearchForm: {
                            sensor_type: sensorTypeItem.type,
                            health_status: param.seriesName === '故障' ? 0 : 1
                        }
                    }
                })
            });
            this.myChart4.setOption(option);
            this.resizeCharts();
        },
        getProperty(obj, str) {
            str = str.replace(/\[(\w+)\]/g, ".$1"); // 处理数组下标
            let arr = str.split(".");
            for (let i in arr) {
                obj = obj[arr[i]] || "";
            }
            return obj;
        },
        // 处理在线率
        dealPersent(obj) {
            return obj.total === 0 ? 0 : ((obj.online_count / obj.total) * 100).toFixed(2);
        },
        // 确认
        handle(row) {
            this.detailsInfo = row;
            this.showDetails = true;
        },
        // 查看
        showChart(row) {
            this.loading = this.$loading({
                target: '.el-dialog',          
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                if ([3,4,5,6].includes(row.alarm_level)){
                    this.dataDetails = [row];
                    if ([3,4,5,6].includes(row.alarm_level)) {
                        this.trendSelectData = []
                        this.trendSelectData.push(row)
                        warning.getTrendAlarmDataList({trend_alarm_id: row.trend_alarm_detail_id}).then(val => {
                            this.trend_char_data = val.data
                            this.loading.close()
                            this.showTrendDetails = true;
                        }).catch(err => {
                        })
                    }
                }else {
                    let equipment_id = row.equipment_id
                    let start_date = row.create_date
                    let max_query_num = 100
                    const params = {
                        equipment_id: equipment_id,
                        body: {
                            start_date: start_date,
                            max_query_num: max_query_num
                        }
                    }
                    device.findNearData(params).then(res => {
                        const { data = [] } = res; // 解构并默认空数组，避免报错
                        
                        // 空数据提前处理
                        if (data.length === 0) {
                            this.$message.warning("历史数据已被清理");
                            outLoading.close();
                            return;
                        }

                        // 1. 提取当前传感器数据（最优先）
                        const currentSensorData = data.filter(item => 
                            item.sensor_data_id === row.sensor_data_id
                        );

                        // 2. 分离其他数据（排除当前传感器）
                        const otherData = data.filter(item => 
                            item.sensor_data_id !== row.sensor_data_id
                        );

                        // 定义局放类型常量
                        const pdTypes = ["HFCT", "UHF", "AE", "TEV", "PC"];
                        const currentType = row.sensor_type; // 当前传感器类型

                        const [sameType, pdData, remainingData] = otherData.reduce((acc, item) => {
                            const [same, pd, remaining] = acc;
                            
                            if (item.sensor_type === currentType) {
                            // 3.1 同类型（非当前传感器）
                            same.push(item);
                            } else if (pdTypes.includes(item.sensor_type)) {
                            // 3.2 局放类型（非当前类型）
                            pd.push(item);
                            } else {
                            // 3.3 剩余其他类型
                            remaining.push(item);
                            }
                            
                            return acc;
                        }, [[], [], []]); // 初始值：[同类型, 局放类型, 剩余类型]

                        // 4. 按优先级合并：自己 → 同类型 → 局放 → 剩余
                        this.dataDetails = [].concat(
                            currentSensorData,
                            sameType,
                            pdData,
                            remainingData
                        );

                        this.showChartDetails = true;
                        this.loading.close()
                    });
                }
            } catch(err) {
                this.loading.close()
                console.log('请求失败：', err)
            }
        }

    }
}
</script>

<style lang="less" scoped>
.refresh {
    width: 24px;
    height: 24px;
    position: absolute;
    top: -60px;
    right: 400px;

    i {
        font-size: 24px;
        color: #fff;
    }
}

/deep/.el-input__inner {
    background: #2C2F32;
}

/deep/.el-input{
    text-align: center;
    padding:5px 0;
    background: #2C2F32;
    font-size: 13px
}
.grid-content {
    height: 100%;
    display: flex;

    .content-box {
        height: 100%;
        width: 100%;
        display: flex;
        flex: 1;
        flex-flow: column;
        position: relative;

        /deep/.ec-extension-bmap {
            // height:calc(100% - 10px) !important
        }

        .map-tree {
            height: 300px;
            position: absolute;
            max-height: calc(100% - 100px);
            background: #2C2F32;
            width: 200px;
            background: #ccc;
            z-index: 1000;

            .map-tree-title {
                height: 38px;
                background: #4A4C4F;
                line-height: 38px;
                color: #fff;
                padding: 0 10px;

            }

            .tree-box {
                background: #2C2F32;
            }

            /deep/.el-tree {
                background: #2C2F32;
                color: #fff;
                white-space: nowrap;
                text-overflow: ellipsis;

                .span-ellipis {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

            /* 导航栏树组件滚动条样式 */
            .tree-box {
                overflow-x: hidden;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 6px;
                    background: #2C2F32;
                }

                &::-webkit-scrollbar-track {
                    background: #2C2F32;
                    border-radius: 3px;
                }

                &::-webkit-scrollbar-thumb {
                    background: #4A4C4F;
                    border-radius: 3px;

                    &:hover {
                        background: #5A5C5F;
                    }
                }

                &::-webkit-scrollbar-button {
                    display: none;
                }
            }
        }

        .line-navigation {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;

            .map-tree {
                position: relative;
                width: 100%;
                height: 100%;
                max-height: none;
                background: #2C2F32;
            }

            .line-content {
                    padding: 20px;
                    background: #2C2F32;
                    height: calc(100% - 38px);
                    color: #fff;
                    display: flex;
                    flex-direction: column;

                    .line-title {
                        font-size: 18px;
                        font-weight: bold;
                        margin-bottom: 20px;
                        text-align: center;
                    }

                    .company-container {
                        flex: 1;
                        overflow-y: auto;
                        padding: 10px;

                        /* 自定义滚动条样式 */
                        &::-webkit-scrollbar {
                            width: 8px;
                            background: #2C2F32;
                        }

                        &::-webkit-scrollbar-track {
                            background: #2C2F32;
                            border-radius: 4px;
                            border: 1px solid #3A3D40;
                        }

                        &::-webkit-scrollbar-thumb {
                            background: #5A5C5F;
                            border-radius: 4px;
                            border: 1px solid #4A4C4F;

                            &:hover {
                                background: #6A6C6F;
                            }
                        }

                        &::-webkit-scrollbar-button {
                            display: none;
                        }

                        .company-section {
                            margin-bottom: 30px;

                            .company-title {
                                font-size: 16px;
                                font-weight: bold;
                                margin-bottom: 15px;
                                color: #73D1EB;
                                padding-bottom: 5px;
                                border-bottom: 1px solid #4A4C4F;
                            }

                            .company-header {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                margin-bottom: 15px;
                                padding-bottom: 10px;
                                border-bottom: 1px solid #4A4C4F;
                            }
                            
                            .company-title {
                                font-size: 16px;
                                font-weight: bold;
                                color: #73D1EB;
                            }
                            
                            .company-stats {
                                display: flex;
                                gap: 15px;
                            }
                            
                            .stat-item {
                                font-size: 12px;
                                color: #fff;
                                background: rgba(115, 209, 235, 0.2);
                                padding: 3px 8px;
                                border-radius: 12px;
                            }
                            
                            .site-grid {
                                display: grid;
                                grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
                                gap: 8px;
                            }
                            
                            .site-card {
                                background: #3A3D40;
                                border: 1px solid #4A4C4F;
                                border-radius: 6px;
                                padding: 10px;
                                transition: all 0.3s ease;
                                position: relative;
                                overflow: hidden;

                                &:hover {
                                    transform: translateY(-2px);
                                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                                    border-color: #73D1EB;
                                }

                                &.has-alarm {
                                    background: rgba(255, 75, 75, 0.25);
                                    border-color: rgba(255, 75, 75, 0.5);
                                }
                                
                                &.has-warning {
                                    background: rgba(255, 193, 7, 0.25);
                                    border-color: rgba(255, 193, 7, 0.5);
                                }
                            }
                            
                            .site-header {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                margin-bottom: 8px;
                            }
                            
                            .site-name {
                                font-size: 12px;
                                font-weight: 600;
                                color: #fff;
                                flex: 1;
                                word-break: break-word;
                                margin-right: 8px;
                            }
                            
                            .site-status {
                                font-size: 8px;
                                font-weight: bold;
                                padding: 2px 6px;
                                border-radius: 10px;
                                text-transform: uppercase;
                                letter-spacing: 0.5px;
                            }
                            
                            .status-normal {
                                background: rgba(88, 233, 129, 0.2);
                                color: #58e981;
                                border: 1px solid rgba(88, 233, 129, 0.3);
                            }
                            
                            .status-alarm {
                                background: rgba(255, 75, 75, 0.2);
                                color: #ff4b4b;
                                border: 1px solid rgba(255, 75, 75, 0.3);
                            }
                            
                            .status-warning {
                                background: rgba(255, 193, 7, 0.2);
                                color: #ffc107;
                                border: 1px solid rgba(255, 193, 7, 0.3);
                            }
                            
                            .site-info {
                                margin-bottom: 15px;
                                padding: 10px;
                                background: rgba(255, 255, 255, 0.05);
                                border-radius: 4px;
                            }
                            
                            .info-item {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                font-size: 12px;
                            }
                            
                            .info-label {
                                color: #aaa;
                            }
                            
                            .info-value {
                                color: #fff;
                                font-weight: 500;
                            }
                            
                            .site-actions {
                                display: flex;
                                gap: 8px;
                            }
                            
                            .action-btn {
                                flex: 1;
                                font-size: 10px;
                                padding: 6px 10px;
                                border: none;
                                border-radius: 4px;
                                cursor: pointer;
                                transition: all 0.3s ease;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                gap: 4px;
                                font-weight: 500;
                            }
                            
                            .detail-btn {
                                background: #3A3D40;
                                color: #73D1EB;
                                border: 1px solid #4A4C4F;
                            }
                            
                            .alarm-btn {
                                background: #3A3D40;
                                color: #ff4b4b;
                                border: 1px solid #4A4C4F;
                            }
                            
                            .action-btn:hover {
                                transform: translateY(-1px);
                                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
                            }
                            
                            .detail-btn:hover {
                                background: #4A4C4F;
                                border-color: #73D1EB;
                            }
                            
                            .alarm-btn:hover {
                                background: #4A4C4F;
                                border-color: #ff4b4b;
                            }
                            
                            .alarm-btn {
                                position: relative;
                            }
                            
                            .alarm-badge {
                                position: absolute;
                                top: -5px;
                                right: -5px;
                                background: #dc3545;
                                color: white;
                                font-size: 8px;
                                font-weight: bold;
                                border-radius: 50%;
                                min-width: 16px;
                                height: 16px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                padding: 0 4px;
                            }
                        }
                    }
                }

                &.fullscreen {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    z-index: 9999;
                    background: #2C2F32;
                    overflow: hidden;

                    .map-tree {
                        height: 100vh;
                    }

                    .line-content {
                        height: calc(100vh - 38px);
                    }
                }
        }
    }

    .property-box,
    .state-box,
    .unusual-box,
    .map-box,
    .notify,
    .point-box,
    .online-box,
    .fault-box,
    .unusual-deal {
        background: #17191A;
        margin: 10px;
        position: relative;
    }

    .property-box,
    .state-box,
    .unusual-box {
        background: #17191A;
        min-height: 0;
    }

    .property,
    .state,
    .unusual {
        height: 100%;
    }

    .map {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    .middle-content-box {
        gap: 10px;
        padding: 10px;
        box-sizing: border-box;
        overflow: hidden;

        > .map-box,
        > .notify {
            margin: 0;
            min-height: 0;
        }

        > .map-box {
            flex: 0 0 48%;
            height: auto;
            overflow: hidden;
        }

        > .notify {
            flex: 1 1 0;
            height: auto;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
    }

    .bg-purple.content-box {
        gap: 10px;
        padding: 10px;
        box-sizing: border-box;
        overflow: hidden;

        > .property-box,
        > .state-box,
        > .unusual-box {
            margin: 0;
        }

        > .property-box {
            flex: 0.9 1 0;
            min-height: 150px;
        }

        > .state-box,
        > .unusual-box {
            flex: 1 1 0;
            min-height: 160px;
        }
    }

    .map-box > div {
        height: 100%;
        position: relative;
    }

    .notify {
        height: 400px;
    }

    .point {
        padding-bottom: 24px;
        position: relative;
    }

    .right-chart-column {
        gap: 6px;
        padding: 6px;
        box-sizing: border-box;
        overflow: hidden;

        > .point-box,
        > .online-box,
        > .fault-box,
        > .unusual-deal {
            margin: 0;
            min-height: 0;
        }

        > .point-box {
            flex: 1 1 auto;
            height: auto;
            min-height: 160px;
        }

        > .online-box,
        > .fault-box {
            flex: 0 0 25%;
            height: auto;
            min-height: 96px;
        }

        > .unusual-deal {
            flex: 0 0 150px;
            height: auto;
        }

        .online,
        .fault {
            height: 100%;
            min-height: 88px;
        }
    }

    .point-box {
        height: 40%;
        position: relative;
    }

    .scroll-box-x {
        height: calc(100% - 55px);
        overflow-x: auto;
        overflow-y: hidden;

        /* 自定义滚动条样式 */
        &::-webkit-scrollbar {
            height: 8px;
            background: #1E2022;
        }

        &::-webkit-scrollbar-track {
            background: #1E2022;
            border-radius: 4px;
            border: 1px solid #3A3D40;
        }

        &::-webkit-scrollbar-thumb {
            background: #5A5C5F;
            border-radius: 4px;
            border: 1px solid #4A4C4F;

            &:hover {
                background: #6A6C6F;
            }
        }

        &::-webkit-scrollbar-button {
            display: none;
        }
    }

    .scroll-box-y {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;

        /* 自定义滚动条样式 */
        &::-webkit-scrollbar {
            width: 8px;
            background: #1E2022;
        }

        &::-webkit-scrollbar-track {
            background: #1E2022;
            border-radius: 4px;
            border: 1px solid #3A3D40;
        }

        &::-webkit-scrollbar-thumb {
            background: #5A5C5F;
            border-radius: 4px;
            border: 1px solid #4A4C4F;

            &:hover {
                background: #6A6C6F;
            }
        }

        &::-webkit-scrollbar-button {
            display: none;
        }
    }
    .state-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // padding: 10px 15px;
        padding-bottom: 5px;
        padding-right: 15px;
        gap: 10px;
        min-width: 0;

        .notify-title {
            flex: 0 0 auto;
            white-space: nowrap;
            word-break: keep-all;
        }
    }

    .chart-title {
        position: relative;
        width: auto;
        height: 30px;
        line-height: 30px;
        top: auto;
        left: 0;
        color: #fff;
        z-index: 99;
        padding-top: 6px;
        padding-bottom: 4px;
        padding-left: 4px;
        background-color: #17191a;
        img {
            width: 16px;
            height: 16px;
            margin: 4px;
            vertical-align: middle;
        }
    }

    .chart-legend {
        display: flex;
        gap: 12px;
        flex: 1 1 auto;
        flex-wrap: nowrap;
        justify-content: flex-end;
        min-width: 0;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .legend-item {
        display: flex;
        align-items: center;
        gap: 4px;
        flex: 0 0 auto;
    }

    .legend-color {
        width: 20px;
        height: 14px;
        border-radius: 4px;
    }

    .legend-text {
        font-size: 11px;
        color: #fff;
    }
    .cape-header::before {
        position: absolute;
        width: 30px;
        height: 15px;
        content: '';
        left: 0px;
        top: 0px;
        border-top: solid 2px #73D1EB;
        border-left: solid 1px #73D1EB;
        z-index: 1000;
    }

    .cape-header::after {
        position: absolute;
        height: 30px;
        width: 15px;
        content: '';
        right: 0px;
        top: 0px;
        border-top: solid 1px #73D1EB;
        border-right: solid 2px #73D1EB;
    }

    .cape-footer {
        position: relative;
    }

    .cape-footer::before {
        position: absolute;
        height: 30px;
        width: 15px;
        content: '';
        left: 0px;
        bottom: 0px;
        border-bottom: solid 2px #73D1EB;
        border-left: solid 1px #73D1EB;
    }

    .cape-footer::after {
        position: absolute;
        width: 30px;
        height: 15px;
        content: '';
        right: 0px;
        bottom: 0px;
        border-bottom: solid 1px #73D1EB;
        border-right: solid 2px #73D1EB;
    }

    .notify .cape-footer::before {
        position: absolute;
        height: 30px;
        width: 15px;
        content: '';
        left: -1px;
        bottom: -12px;
        border-bottom: solid 2px #73D1EB;
        border-left: solid 1px #73D1EB;
    }

    .notify .cape-footer::after {
        position: absolute;
        width: 30px;
        height: 15px;
        content: '';
        right: -1px;
        bottom: -12px;
        border-bottom: solid 1px #73D1EB;
        border-right: solid 2px #73D1EB;
    }

    .unusual-deal .cape-footer::before {
        position: absolute;
        height: 30px;
        width: 15px;
        content: '';
        left: -1px;
        bottom: -12px;
        border-bottom: solid 2px #73D1EB;
        border-left: solid 1px #73D1EB;
    }

    .unusual-deal .cape-footer::after {
        position: absolute;
        width: 30px;
        height: 15px;
        content: '';
        right: -1px;
        bottom: -12px;
        border-bottom: solid 1px #73D1EB;
        border-right: solid 2px #73D1EB;
    }

    .map-box.cape-header::before {
        position: absolute;
        width: 70px;
        height: 70px;
        content: '';
        left: -6px;
        top: -6px;
        border-top: solid 6px #fff;
        border-left: solid 6px #fff;
    }

    .map-box.cape-header::after {
        position: absolute;
        height: 30px;
        width: 30px;
        content: '';
        right: -6px;
        top: -6px;
        border-top: solid 6px #fff;
        border-right: solid 6px #fff;
    }

    .map-box .cape-footer::before {
        position: absolute;
        height: 30px;
        width: 30px;
        content: '';
        left: -6px;
        bottom: -6px;
        border-bottom: solid 6px #fff;
        border-left: solid 6px #fff;
    }

    .map-box .cape-footer::after {
        position: absolute;
        width: 70px;
        height: 70px;
        content: '';
        right: -6px;
        bottom: -6px;
        border-bottom: solid 6px #fff;
        border-right: solid 6px #fff;
    }

    .online-box {
        height: 20%
    }

    .online {
        height: 100%
    }

    .fault-box {
        height: 20%
    }

    .unusual-deal {
        height: 20%
    }

    .notify-title {
        height: 36px;
        flex: 0 0 36px;
        line-height: 36px;
        padding-left: 5px;
        color: #fff;
        font-size: 16px;

        img {
            width: 20px;
            height: 20px;
            margin-top: 6px;
            float: left;
            margin-right: 5px;
        }
    }

    .notify-table {
        /deep/.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
            background: #2C2E30
        }

        width:calc(100% - 60px);
        margin:0 auto;
        height:auto;
        flex: 1 1 0;
        min-height: 0;
        overflow: hidden;

        .el-table {
            height: 100%;
            background: #212325;
            border-color: #2C2E30;
            overflow-y: auto;

            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 8px;
                background: #1E2022;
            }

            &::-webkit-scrollbar-track {
                background: #1E2022;
                border-radius: 4px;
                border: 1px solid #3A3D40;
            }

            &::-webkit-scrollbar-thumb {
                background: #5A5C5F;
                border-radius: 4px;
                border: 1px solid #4A4C4F;

                &:hover {
                    background: #6A6C6F;
                }
            }

            &::-webkit-scrollbar-button {
                display: none;
            }
        }

        /deep/.el-table th,
        /deep/.el-table tr,
        /deep/.el-table td {
            background: #212325;
            border-color: #2C2E30;
            padding: 0px;
            color: #fff;
            text-align: center;
            font-size: 12px;
        }

        /deep/.el-table th {
            background: #2C2E30
        }

        /deep/.el-table th.el-table__cell.is-leaf {
            height: 30px;
        }

        /deep/.el-table__body-wrapper {
            height: calc(100% - 30px) !important;
            overflow-y: auto;
        }

        /deep/.el-table__empty-block {
            min-height: 100%;
            height: 100%;
        }
    }

    .deal-box {
        display: flex;
        height: calc(100% - 46px);
        color: #fff;
    }

    .deal-describ {
        width: 40%;
        height: 100%;
        text-align: center;

        span {
            display: block;
            height: 40px;
            line-height: 40px;
            ;
        }

        p {
            height: 30px;
            line-height: 30px;
            ;
        }
    }

    .el-icon-message-solid {
        color: #72DBFF;
        font-size: 46px;
    }

    .deal-num {
        width: 60%;

        table td {
            width: 33%;
            text-align: center;
            height: 32px;
        }
    }
}

@media screen and (max-height: 760px) {
    .grid-content {
        .bg-purple.content-box {
            gap: 6px;
            padding: 6px;

            > .property-box {
                min-height: 130px;
            }

            > .state-box,
            > .unusual-box {
                min-height: 135px;
            }
        }

        .right-chart-column {
            gap: 4px;
            padding: 4px;

            > .unusual-deal {
                flex-basis: 126px;
            }
        }
    }
}

.property-content {
    width: calc(100% - 60px);
    height: calc(100% - 60px);
    margin: auto;
    border: solid 2px #EBF3FA;
    padding: 10px;

    .content-title {
        width: 100%;
        text-align: center;
        color: #fff;
    }

    .b-content-box {
        display: flex;
        justify-content: center;
        margin-top: 15px;

        .content-item {
            width: 120px;
            color: #fff;
            display: flex;

            p {
                text-align: center;
                padding-left: 5px;
            }

            img {
                width: 50px;
                height: 50px;
            }
        }
    }
}

/deep/.map-tree {
    .tree-box .el-tree-node__content:hover {
        background-color: #F5F7FA;
        color: #409EFF;
    }
}
.link:hover {
    color: #fa3333ff;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/sum/sum.vue